<template>
  <div>
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <!--select-->
      <div class="details-parameter-tit" v-if="this.$route.query.sourceId">
        <i class="el-icon-back" @click="ret()"></i>
        <i style=""></i>
        <span v-if="njInfoData.njInfo&&njInfoData.njInfo">{{njInfoData.njInfo.itemName}}详情</span>
        <!--<span class="details-ret" @click="ret()">-->
          <!--<img src="../../../static/img/ret.png" alt=""><span>返回</span>-->
        <!--</span>-->
      </div>
      <div class="details-parameter-tit" v-else>
        <i class="el-icon-back" @click="ret()"></i>
        <i style=""></i>
        <span v-if="details.njInfo&&details.njInfo">{{details.njInfo.titleName}}详情</span>
        <!--<span class="details-ret" @click="ret()">-->
          <!--<img src="../../../static/img/ret.png" alt=""><span>返回</span>-->
        <!--</span>-->
      </div>
      <div class="details-parameter" v-if="this.$route.query.sourceId">
        <div class="details-parameter-left">
          <div class="parameter-njxx">
            <img src="../../../static/img/njxx-icon.png" alt="">
            <span style="color: #fff;">农机信息</span>
          </div>
          <table class="parameter-table" v-if="njInfoData.njInfo">
            <tr>
              <td style="text-align: left;">农机名称</td>
              <td style="">{{njInfoData.njInfo.njName}}</td>
              <td style="width: 20%">出厂编号</td>
              <td>{{njInfoData.njInfo.factoryCode}}</td>
              <td width="20%">机主</td>
              <td style="max-width:10px;" v-bind:title="njInfoData.njInfo.driverName">{{njInfoData.njInfo.driverName}}</td>
            </tr>
            <tr>
              <td style="">生产企业</td>
              <td>{{njInfoData.njInfo.factoryName}}</td>
              <td>监控编号</td>
              <td>{{njInfoData.njInfo.imei}}</td>
              <td >补贴金额</td>
              <td style="min-width: 80px" v-if="njInfoData.njInfo.totalSubsidy!=='-'">{{njInfoData.njInfo.totalSubsidy}}元</td>
              <td style="min-width: 80px" v-else>{{njInfoData.njInfo.totalSubsidy}}</td>
            </tr>
            <tr>
              <td style="text-align: center;padding: 0 0 0 5px;">经销商</td>
              <td>{{njInfoData.njInfo.dealerName}}</td>
              <td style="">补贴进度</td>
              <td>{{njInfoData.njInfo.isSubsidy}}</td>
              <td >补贴地址</td>
              <td v-bind:title="njInfoData.njInfo.subsidyAddr">{{njInfoData.njInfo.subsidyAddr}}</td>
            </tr>
          </table>
          <div v-else style="text-align: center;line-height: 60px;margin-top:30px;font-size: 34px;color:#999;display: inline-block">暂无数据</div>
          <div class="details-parameter-ewm">
            <p style="color: #75c3ff;margin-bottom: 0.5vw;font-size: 0.83vw;">农机身份二维码</p>
            <div class="" v-if="njInfoData.njInfo&&njInfoData.njInfo.qrCode !=='-'" style="text-align: center;">
              <img :src="njInfoData.njInfo.qrCode" style="width:5vw;height:9vh;">
            </div>
          </div>
        </div>
        <div class="details-parameter-right">
         <div class="parameter-njxx">
           	<img style="height: 2vh;" src="../../../static/img/runImg.png" alt="">
          <span style="color: #fff;">运行信息</span>
          </div>
          <table class="details-running" v-if="njInfoData&&njInfoData.njInfo" style="position: relative">
            <tr >
              <td >总时长</td>
              <td>{{njInfoData.runInfo.sumRunHour==null?'--':njInfoData.runInfo.sumRunHour}}小时</td>
              <td>总里程</td>
              <td>{{njInfoData.runInfo.sumMileage==null?'--':njInfoData.runInfo.sumMileage}}公里</td>
              <td>总面积</td>
              <td>{{njInfoData.runInfo.sumArea==null?'--':njInfoData.runInfo.sumArea}}亩</td>
            </tr>
              <div style="position: absolute;left: 5px;top:50px">
                <div v-if="njInfoData.isWorkToday==1"><el-button type="primary" @click="tadayRecord()">今日作业</el-button></div>
                <div v-else style="color: #eee"><el-button type="info">今日作业</el-button></div>
              </div>
          </table>
          <div v-else style="text-align: center;line-height: 70px;font-size: 34px;color:#999">暂无数据</div>
        </div>
      </div>
      <div class="details-parameter" v-else>
        <div class="details-parameter-left">
          <div class="parameter-njxx">
            <img src="../../../static/img/njxx-icon.png" alt="">
            <span style="color: #fff;">农机信息</span>
          </div>
          <table class="parameter-table" v-if="details.njInfo">
            <tr>
              <td style="text-align: left;">农机名称</td>
              <td style="">{{details.njInfo.nj_name}}</td>
              <td style="width: 20%">出厂编号</td>
              <td>{{details.njInfo.factory_code}}</td>
              <td width="20%">机主</td>
              <td style="max-width:10px;" v-bind:title="details.njInfo.name">{{details.njInfo.name}}</td>
            </tr>
            <tr>
              <td style="">生产企业</td>
              <td>{{details.njInfo.factory_name}}</td>
              <td>监控编号</td>
              <td>{{details.njInfo.imei}}</td>
              <td >补贴金额</td>
              <td style="min-width: 80px" v-if="details.njInfo.total_subsidy==0?'--':details.njInfo.total_subsidy">{{details.njInfo.total_subsidy}}元</td>
            </tr>
            <tr>
              <td style="text-align: center;padding: 0 0 0 5px;">经销商</td>
              <td>{{details.njInfo.dealer_name}}</td>
              <td style="">补贴进度</td>
              <td>{{details.njInfo.is_subsidy}}</td>
              <td >补贴地址</td>
              <td v-bind:title=details.njInfo.subAddress>{{details.njInfo.subAddress}}</td>
            </tr>
          </table>
          <div v-else style="text-align: center;line-height: 60px;margin-top:30px;font-size: 34px;color:#999;display: inline-block">暂无数据</div>
          <div class="details-parameter-ewm" v-if="details.njInfo.qr_code">
            <p style="color: #75c3ff;margin-bottom: 0.5vw;font-size: 0.83vw;">农机身份二维码</p>
            <div class="" style="text-align: center;">
              <img :src="details.njInfo.qr_code" style="width:5vw;height:9vh;">
            </div>
          </div>
        </div>
        <div class="details-parameter-right">
        	<div class="parameter-njxx">
           	<img style="height: 2vh;" src="../../../static/img/runImg.png" alt="">
          <span style="color: #fff;">运行信息</span>
          </div>
        
          <table class="details-running" v-if="details&&details.njInfo" style="position: relative">
            <tr >
              <td >总时长</td>
              <td>{{details.njRunInfo.sumRunHour==null?'--':details.njRunInfo.sumRunHour}}小时</td>
              <td>总里程</td>
              <td>{{details.njRunInfo.sumMileage==null?'--':details.njRunInfo.sumMileage}}公里</td>
              <td>总面积</td>
              <td>{{details.njRunInfo.sumArea==null?'--':details.njRunInfo.sumArea}}亩</td>
            </tr>
            <div style="position: absolute;left: 5px;top:50px">
              <div v-if="details.isWorkToday==1"><el-button type="primary" @click="tadayRecord()">今日作业</el-button></div>
              <div v-else style="color: #eee"><el-button type="info">今日作业</el-button></div>
            </div>
          </table>
          <div v-else style="text-align: center;line-height: 70px;font-size: 34px;color:#999">暂无数据</div>
        </div>
      </div>
      <div class="details-table-title">
        <img src="../../../static/img/detail-run-icon.png" alt="">
        <span>运行记录</span>
        <el-button type="primary" style="margin-left: 0.5vw"  @click="LocalRecord()">查看历史作业位置</el-button>
        <div class="block" style="display: inline-block;float: right">
          <div class="swiper_box">
            <div class="swiper-father">
              <div class="swiper-container container_box">
                <div class="swiper-wrapper">
                  <div :class="['swiper-slide',isActiveWorkType==index ? 'active' : '' ]" v-for="(item,index) in yearData" :key="index" @click="typeClick(index,item)">{{item}}年</div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: inline-block;margin-right: 30px;color: #75c3ff">
            <el-checkbox v-model="checkZero"  @change="displayZreo" style="color: #409EFF">显示 ‘0亩’</el-checkbox>
            <!--<label for="是否显示 ‘0亩’"></label>-->
            <!--<el-radio v-model="checkZero" label="0" style="color: #fff" @change="displayZreo">是</el-radio>-->
            <!--<el-radio v-model="checkZero" label="1" style="color: #fff" @change="displayZreo">否</el-radio>-->
          </div>
          <span class="demonstration">时间</span>
          <el-date-picker
            v-model="value2"
            type="month"
            placeholder="选择月"
            value-format="yyyy-MM"
          >
          </el-date-picker>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </div>
      </div>
      <el-main style="margin-top:1vh;padding:0;">
        <el-table
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column
            prop="id"
            label="序号"
            width="180"
            type="index"
          >
            <template slot-scope="scope">
              <span>{{ (currentPage-1)*checkcurrentPage+parseInt(scope.$index)+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="stat_time"
            label="日期"
            width="180">
          </el-table-column>
          <el-table-column
            prop="run_time_day"
            label="运行时长">
            <template slot-scope="scope">
              <div v-if="scope.row.run_time_day !==''">{{scope.row.run_time_day+'小时'}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="mileage_day"
            label="运行里程">
            <template slot-scope="scope">
              <div v-if="scope.row.mileage_day !==''">{{scope.row.mileage_day+'公里'}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="predictArea"
            label="预计作业面积">
            <template slot-scope="scope">
              <div v-if="scope.row.predictArea !==''">{{scope.row.predictArea+'亩'}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="workArea"
            :show-overflow-tooltip="true"
            label="作业地区">
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="trajectory(scope.row)" type="text" size="small">轨迹查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="nodata" class="zanwu">暂无数据</div>
      </el-main>
      <div v-if="isloading" class="">
        <div class="el-loading-spinner"><i class="el-icon-loading"></i><p class="el-loading-text">加载中</p></div>
      </div>
      <div class="blocks">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="checkcurrentPage"
          layout="total, prev, pager, next, jumper"
          :total="total"
          v-if="tableData&&tableData[0]"
        >
        </el-pagination>
      </div>
    </el-container>
  </div>
</template>

<script>
  import Api from '../../Serves/net-api.js'
  import Http from '../../Serves/net-http.js'
  import {mapState,mapActions,mapMutations} from "vuex";
  export default {
    name: "MonitorDetails",
    components: {},
    computed:{
      ...mapState({
        details:state=>state.details,
        imei:state=>state.imei,
        time:state=>state.time
      })
    },
    data() {
      return {
        isloading:true,
        nodata:false,
        // loading:false,//表格加载状态
        checkZero: false,
        total:1,
        pageSize:'',
        currentPage:1,
        checkcurrentPage:9,
        currentPage1: 5,
        currentPage2: 5,
        currentPage3: 5,
        currentPage4: 4,
        //imei:'',
        formInline: {
          user: '',
          region: ''
        },
        value: [],
        value2: '',
        tableData: [],
        njInfoData: {},
        yearData: [],
        isActiveWorkType: 0,
        year: new Date().getFullYear()
      }
    },
    mounted(){
      this.getYear()
      var imei = this.$route.query?this.$route.query.imei:this.Info.Info.imei
      this.$store.state.imei = imei?imei:this.$store.state.imei // 更改后
      // this.getdata()
      this.getDetails()
      var manage = JSON.parse(sessionStorage.getItem('manageParams1'))
      if (manage === undefined || manage === null) {
        this.getdata()
      } else {
        this.value2 = manage.startTime
        this.checkZero = manage.checkZero
        this.currentPage = manage.currentPage
        this.checkcurrentPage = manage.pageSize
        this.isActiveWorkType = manage.isActiveWorkType;
        this.year = manage.year
        if (this.$route.query.id === undefined) {
          var parmse={
            startTime: manage.startTime,
            imei: this.$route.query.qrNumber?undefined:this.$route.query.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            source: this.$route.query.source,
            year: manage.year,
            currentPage:manage.currentPage,
            pageSize:manage.pageSize,
            checkZero:manage.checkZero === true ? 0 : 1
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        } else {
          var parmse={
            startTime: manage.startTime,
            // imei:this.$route.query.imei,
            // njId: this.$route.query.id,
            njId: this.$route.query.qrNumber?undefined:this.$route.query.id,
            imei: this.$route.query.qrNumber?undefined:this.$route.query.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            currentPage:manage.currentPage,
            year: manage.year,
            pageSize:manage.pageSize,
            checkZero:manage.checkZero === true ? 0 : 1
          }
          var url=Http.test+'/purchaseSubsidyMonitor/workRecordList'
        }
        this.isloading = true
        Api.doPost(url,parmse,false,(res)=>{
          this.isloading = false 
          this.tableData=res.result.dataSource
          this.total = res.result.totalRow
          if(this.tableData.length==0){
            this.nodata=true
          }else{
            this.nodata=false
          }
        },(doError)=>{
        })
      }
    },
    // beforeDestroy () {
    //   sessionStorage.removeItem('manageParams')
    // },
    methods: {
      ...mapActions(['getListNjDetails']),
      ...mapMutations(['saveTabkeInfo']),
      handleChange(value) {
      },
      ret(){
        this.$router.go(-1)
      },
      getYear () {
        var dd = new Date()
        var year1 = dd.getFullYear()
        var year2 = dd.getFullYear() - 1
        var year3 = dd.getFullYear() - 2
        var year4 = dd.getFullYear() - 3
        var year5 = dd.getFullYear() - 4
        this.yearData = [year1,year2,year3,year4,year5]
      },
      typeClick(index, item) {
        this.isActiveWorkType = index
        this.year = item
        this.getdata()
      },
      displayZreo(){
        this.nodata=false
        if (this.$route.query.id === undefined) {
          var parmse={
            startTime:this.value2==''? '':this.value2,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            source: this.$route.query.source,
            checkZero:this.checkZero === true ? 0 : 1,
            year: this.year,
            currentPage:this.currentPage,
            pageSize: 9
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==''? '':this.value2,
            // imei:this.imei,
            // njId: this.$route.query.id,
            njId: this.$route.query.qrNumber?undefined:this.$route.query.id,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            checkZero:this.checkZero === true ? 0 : 1,
            year: this.year,
            currentPage:this.currentPage,
            pageSize: 9
          }
          var url=Http.test+'/purchaseSubsidyMonitor/workRecordList'
        }
        
        Api.doPost(url,parmse,false,(res)=>{
          this.tableData=res.result.dataSource
          this.total = res.result.totalRow
          if(this.tableData.length==0){
            this.nodata=true
          }else{
            this.nodata=false
          }
        },(doError)=>{
        })
      },
      onSubmit() {
        this.nodata=false
        this.currentPage=1
        if (this.$route.query.id === undefined) {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            checkZero:this.checkZero === true ? 0 : 1,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            source: this.$route.query.source,
            year: this.year,
            currentPage:this.currentPage,
            pageSize:this.checkcurrentPage
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            checkZero:this.checkZero === true ? 0 : 1,
            njId: this.$route.query.qrNumber?undefined:this.$route.query.id,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            year: this.year,
            currentPage:this.currentPage,
            pageSize:this.checkcurrentPage
          }
          var url=Http.test+'/purchaseSubsidyMonitor/workRecordList'
        }
        this.isloading = true
        Api.doPost(url,parmse,false,(res)=>{
          this.isloading = false
          this.tableData=res.result.dataSource
          this.total = res.result.totalRow
          if(this.tableData.length==0){
            this.nodata=true
          }else{
            this.nodata=false
          }
        },(doError)=>{
          console.log(doError)
        })
      },
      // 获取列表数据
      getdata(){
        this.nodata=false
        if (this.$route.query.id === undefined) {
          var parmse={
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            source: this.$route.query.source,
            year: this.year,
            currentPage:this.currentPage,
            pageSize:this.checkcurrentPage,
            checkZero:this.checkZero === true ? 0 : 1,
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        } else {
          var parmse={
            njId: this.$route.query.qrNumber?undefined:this.$route.query.id,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            year: this.year,
            currentPage:this.currentPage,
            pageSize:this.checkcurrentPage,
            checkZero:this.checkZero === true ? 0 : 1,
          }
          // var url='http://192.168.0.118:8087/common/listOperationRecord'
          var url=Http.test+'/purchaseSubsidyMonitor/workRecordList'
        }
        this.isloading = true
        Api.doPost(url,parmse,false,(res)=>{
          this.isloading = false
          this.tableData=res.result.dataSource
          this.total = res.result.totalRow
          if(this.tableData.length==0){
            this.nodata=true
          }else{
            this.nodata=false
          }
        },(doError)=>{
          console.log(doError)
        })
      },
      // 获取参数数据 
      getDetails(){
        if (this.$route.query.id === undefined) {
          var parmse={
            source: this.$route.query.source,
            sourceId: this.$route.query.sourceId
          }
          var url=Http.test+'/dtIotNjData/findById'
          Api.doPost(url,parmse,false,(res)=>{
            this.njInfoData = res.result
          },(doError)=>{
            console.log(doError)
          })
        } else {
          var parmse={
            // imei:this.imei,
            qrNumber: this.$route.query.qrNumber,
            njId: this.$route.query.id,
            njType: this.$route.query.njType
          }
          this.getListNjDetails(parmse);
        }
      },
      //  显示条数控制
      handleSizeChange(val) {
        this.checkcurrentPage=val
        this.currentPage=1
        if (this.$route.query.id === undefined) {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            source: this.$route.query.source,
            currentPage:this.currentPage,
            pageSize:val,
            year: this.year,
            checkZero:this.checkZero === true ? 0 : 1,
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            njId: this.$route.query.qrNumber?undefined:this.$route.query.id,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            currentPage:this.currentPage,
            year: this.year,
            checkZero:this.checkZero === true ? 0 : 1,
            pageSize:val
          }
          var url=Http.test+'/purchaseSubsidyMonitor/workRecordList'
        }
        Api.doPost(url,parmse,false,(res)=>{
          this.tableData=res.result.dataSource
          this.total = res.result.totalRow
        },(doError)=>{
          console.log(doError)
        })
      },
      //分页
      handleCurrentChange(currentPage) {
        // this.currentPage=currentPage;
        if (this.$route.query.id === undefined) {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            source: this.$route.query.source,
            currentPage:currentPage,
            year: this.year,
            checkZero:this.checkZero === true ? 0 : 1,
            pageSize:this.checkcurrentPage
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        } else {
          var parmse={
            startTime: this.value2==null? '':this.value2,
            njId: this.$route.query.qrNumber?undefined:this.$route.query.id,
            imei: this.$route.query.qrNumber?undefined:this.imei,
            qrNumber: this.$route.query.qrNumber?this.$route.query.qrNumber:undefined,
            currentPage: currentPage,
            year: this.year,
            checkZero: this.checkZero === true ? 0 : 1,
            pageSize: this.checkcurrentPage
          }
          var url=Http.test+'/purchaseSubsidyMonitor/workRecordList'
        }
        Api.doPost(url,parmse,false,(res)=>{
          this.tableData=res.result.dataSource
          this.currentPage=currentPage
        },(doError)=>{
          console.log(doError)
        })
      },
      todaytrajectory(imei) {
        var imei = this.imei;//更改过后
        var data={
          imei:imei,
          stat_time:row.stat_time
        }
        this.$router.push({name:'RecordItem',params:data})
        this.$store.commit('time',{"time":row.stat_time})
      },
      trajectory(row) {
        var aa = {
          startTime:this.value2==null? '':this.value2,
          imei:row.imei,
          currentPage:this.currentPage,
          checkZero:this.checkZero,
          pageSize:this.checkcurrentPage,
          year: this.year,
          isActiveWorkType: this.isActiveWorkType
        }
        sessionStorage.setItem('manageParams1', JSON.stringify(aa))
        // var imei = this.imei;//更改过后
        var data={
          imei:row.imei,
          stat_time:row.stat_time,
          source: this.$route.query.source,
          deviceType: row.deviceType,
          qrNumber: row.qrNumber
        }
        this.$router.push({name:'RecordItem',query:data})
        this.$store.commit('time',{"time":row.stat_time})
      },
      tadayRecord() {//今日轨迹
        var imei = this.imei;
        var data={
          imei:this.imei,
          startTime:this.getNowFormatDates(),
          deviceType: this.njInfoData.deviceType
        }
        localStorage.setItem('imei',this.imei)
        localStorage.setItem('startTime', this.getNowFormatDates())
        if (this.$route.query.sourceId) {
          localStorage.setItem('deviceType',this.njInfoData.deviceType)
        } else {
          localStorage.setItem('deviceType',this.details.deviceType)
        }
        this.$router.push({name:'TodayRecordItem',params:data})
      },
      //历史作业轨迹
      LocalRecord(){
        var imei=this.imei//更改
        this.$router.push({name:'LocalRecord',params:{imei:imei,qrNumber: this.$route.query.qrNumber}})
      },
      // 获取去年当前月
      getNowFormatDates() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate
        return currentdate;
      }
    }
  }
</script>

<style scoped>
  .zanwu{
    text-align: center;
    font-size: 30px;
    color:#999;
    width:98%;
    position: absolute;
    top:50%;
  }
  td{
    /* overflow: hidden; */
    word-break: break-all;
    white-space: nowrap;
    /* text-overflow: ellipsis !important; */
    font-size: 0.83vw;
  }
  .el-header{
    height:0px !important;
  }
  .el-table{
    width: 98% !important;
    margin: auto;
    color: #fff;
  }
  .blocks{
    width: 100%;
    margin-top: 1.5vh;
		display: -webkit-box;
		-webkit-box-align: center;
		-webkit-box-pack: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
  .details-parameter-tit{
    width: 98% !important;
    margin: auto;
    height: 3.7vh;
    line-height: 3.7vh;
  }
  .details-parameter-tit i:nth-child(1){
    font-size: 1.1vw;
    font-weight: bold;
    color: #75c3ff;
  }
  .details-parameter-tit i:nth-child(1):hover{
    font-size: 1.1vw;
    font-weight: bold;
    color: #297af5;
    cursor: pointer;
  }
  .details-parameter-tit i:nth-child(2){
    display: inline-block;
    width: 0.3vw;
    height: 1.8vh;
    position: relative;
    top:3px;
    background-color: #297af5
  }
  .details-parameter-tit span{
    display: inline-block;
    font-weight: bold;
    color: #fff;
    font-size: 1vw;
  }
  .details-ret{
    display: inline-block;
    margin-left: 20px;
    cursor: pointer;
    float: none !important;
    position:unset !important;
  }
  .details-ret span{
    display: inline-block;
    margin-left: 5px;
    font-size: 14px;
    font-weight: unset;
    color: #f45a2b;
  }
  .details-parameter{
    /*width: 95% !important;*/
    /*width: 1900px;*/
    margin-left: 1vw;
    /* margin:1vw 0 0 2vh; */
  }
  .details-parameter-left{
    float: left;
    width: 65%;
    /* min-width: 771px; */
    height: 17vh;
    background: url("../../../static/img/details_bg.png" ) no-repeat;
    background-size:100% 100%;
    padding: 1vh 1vw;
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    margin-right: 1vw;
    margin-bottom: 1vh;
  }
  .parameter-njxx{
    height: 2.7vh;
    line-height: 2.7vh;
    font-size: 0.83vw;
    color: #fff;
    width: 40%;
    float: left;
    /*display: inline-block;*/
  }
  .parameter-njxx img{
    height: 1.5vh;
    position: relative;
  }
  .parameter-table{
    /* margin-top: 10px; */
    width: 80%;
    display: inline-block;
  }
  .parameter-table tr td{
    padding: 1vh 5px;
  }
  .parameter-table tr td:nth-child(odd){
    /*width: 15%;*/
    text-align: right;
    color: #75c3ff;
    padding: 0 5px;
  }
  .parameter-table tr td:nth-child(even){
    padding-left: 0;
    color: #bad1ef;
  }
  .details-parameter-ewm{
    float: right;
    display: inline-block;
    margin-right: 10px;
    position: absolute;
    top: 3vh;
    right:10px;
    /*margin-top: -30px;*/
  }
  /*.details-parameter-ewm img{*/
    /*margin: 5px*/
  /*}*/
  .details-parameter-right{
    width: 33%;
    /*min-width: 580px;*/
    height: 17vh;
    display: inline-block;
    box-sizing: border-box;
    background: url("../../../static/img/details_bg2.png" ) no-repeat;
    background-size:100% 100%;
    padding: 1vh 1vw;
  }
  .details-parameter-right p{
    font-size: 0.833vw;
  }
  .details-running{
    margin-top: 0.5vw;
    /* margin-left: 1vh; */
    min-width: 100%;
  }
  .details-running tr{
    min-width: 100%;
  }
  .details-running tr td:nth-child(odd) {
    text-align: right;
    padding : 5px 10px 5px 0;
    color: #75c3ff;
  }
  .details-running tr td:nth-child(even) {
    color: #bad1ef;
    width: 35%;
  }
  .details-table-title{
    width: 98%;
    margin: auto;
    font-size: 0.83vw;
    color: #fff;
  }
  .details-table-title img{
    width: 1vw;
    height: 2vh;
    position: relative;
    top: 0.5vh;
  }
  .demonstration{
    font-size: 14px !important;
    color: #75c3ff !important;
  }
  .swiper-slide {
    width: 72px!important;
    height: 40px;
    text-align: center;
    cursor: pointer;
    word-break: break-all;
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 0 10px;
    /* line-height: 40px; */
    background: #273488;
    margin-right: 10px;
  }
  .active{
    background: #0b50e8;
    color: #ffffff;
  }
  .swiper_box{
    width: 460px;
    float: left;
    margin-right: 20px;
  }
  .swiper_content{
    width: 100%;
    height: 50px;
  }
  .swiper-wrapper{
    width: 100%;
    display: flex;
  }
  .swiper-father{
    width: 100%;
    height: 40px;
    margin: 0 auto;
    position: relative;
  }
  .swiper-container{
    width: 460px;
    margin: 0 auto;
  }
  .container_box{
    margin-left: 0!important;
  }
  .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after{
    font-size: 22px;
  }
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
    font-size: 22px;
  }
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
    background: #cccccc;
    color: rgba(0, 0, 0, 0.65);
    left: 0;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev{
    background: #cccccc;
    color: rgba(0, 0, 0, 0.65);
    right: 0;
  }
  .swiper-button-next, .swiper-button-prev{
    cursor: pointer;
    z-index: 10;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableList/DiscountDetails.vue